module.exports = "https://trybtryb-legacy.web.app/img/retro-pc.785b9a0c.webp";